@if (opportunityEstimates) {
    <lib-section-sub-header
        [title]="finalSelectedEstimate ? 'Selected Estimate' : 'Base Estimate'"
        [subTitle]="$safeNavigationMigration(baseEstimate?.name)"
        [iconName]="finalSelectedEstimate ? 'dollar' : 'flag'"
        [info]="finalSelectedEstimate ? finalSelectedTemplate : baseEstimateTemplate"
        (subHeaderClicked)="navigate()"
        [selected]="!!finalSelectedEstimate"
    >
        <ng-template #baseEstimateTemplate>
            <div class="info" [ngClass]="{ isBaseEstimate: !finalSelectedEstimate }">
                <div class="item">
                    <div class="label">Sell Price</div>
                    <div class="value">
                        {{ $safeNavigationMigration(baseEstimate?.baseEstimateSellPrice) | currency }}
                    </div>
                </div>
                <div class="item">
                    <div class="label">Gross Margin</div>
                    <div class="value">
                        {{ $safeNavigationMigration(baseEstimate?.grossMarginPercentage) | customPercentage }}
                    </div>
                    @if (!baseEstimate?.grossMarginPercentage) {
                        <div class="value">-</div>
                    }
                </div>
            </div>
        </ng-template>
        <ng-template #finalSelectedTemplate>
            <div class="info" [ngClass]="{ isFinalSelected: finalSelectedEstimate }">
                <div class="item">
                    <div class="label">Base Estimate</div>
                    <div class="value">
                        {{ $safeNavigationMigration(finalSelectedEstimate?.baseEstimateSellPrice) | currency }}
                    </div>
                </div>
                <div class="mathSymbol">+</div>
                <div class="item">
                    <div class="label">Alternate Estimates</div>
                    <div class="value">
                        {{ $safeNavigationMigration(finalSelectedEstimate?.alternateTotalSellPrice) | currency }}
                    </div>
                    @if (!finalSelectedEstimate?.alternateTotalSellPrice) {
                        <div class="value">-</div>
                    }
                </div>
                <div class="mathSymbol">+</div>
                <div class="item">
                    <div class="label">Change Orders</div>
                    <div class="value">
                        {{ $safeNavigationMigration(finalSelectedEstimate?.changeOrderTotalSellPrice) | currency }}
                    </div>
                    @if (!finalSelectedEstimate?.changeOrderTotalSellPrice) {
                        <div class="value">-</div>
                    }
                </div>
                <div class="mathSymbol">=</div>
                <div class="item">
                    <div class="label">Grand Total</div>
                    <div class="value">{{ grandTotal | currency }}</div>
                </div>
                <div class="item">
                    <div class="label">Total Gross Margin</div>
                    <div class="value">
                        {{ $safeNavigationMigration(finalSelectedEstimate?.grossMarginPercentage) | customPercentage }}
                    </div>
                    @if (!finalSelectedEstimate?.grossMarginPercentage) {
                        <div class="value">-</div>
                    }
                </div>
            </div>
        </ng-template>
    </lib-section-sub-header>
}
